import { render } from "./DessinDesktop.vue?vue&type=template&id=e0389030"
import script from "./DessinDesktop.vue?vue&type=script&lang=js"
export * from "./DessinDesktop.vue?vue&type=script&lang=js"

import "./DessinDesktop.vue?vue&type=style&index=0&id=e0389030&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__